import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    region: 'sa-east-1',
    userPoolId: 'sa-east-1_PeVfIQrh3',
    userPoolWebClientId: '7qdq6sfgj3sbgt3tguv7kk29ld',
  },
});
